import { useEffect } from 'react'
import { Button, FormControl, Grid, MenuItem, TextField } from "@mui/material"
import { DownloadCloud } from 'react-feather'

import {
    FileManagerInput,
    LinearLoading,
    CustomAutocomplete
} from '../../../../../../common'


const acceptConfiguration = {
    'image/jpeg': ['.jpeg', '.jpg'],
    'image/png': ['.png'],
    'image/webp': ['.webp']
}

export const SlipSection = ({ useFetchInit, readOnlyMode }) => {

    const {
        Forms,
        Actions,
        FetchData
    } = useFetchInit

    const { FormScreen } = Forms
    const { formState, onInputChange, onSelectSearchChange, onDropZoneAcceptedFilesChange, onDropZoneRejectionsFilesChange } = FormScreen

    const { fetchBanksByCurrency } = FetchData
    const { dataBanksByCurrency, loadingFetchBanksByCurrency } = fetchBanksByCurrency

    const { handleClickDownloadImage } = Actions

    // const sectionReadOnly = readOnlyMode && formState.aprobacion_check !== 'Traslado Aprobado'
    // const sectionReadOnly = readOnlyMode
    useEffect(() => {
                        
        fetchBanksByCurrency.setParamsToSearch({
            currency_type: formState.currency_type // Según el tipo de moneda seleccionado (solo puede transferir a los mismos tipos)
        })
        fetchBanksByCurrency.executeFetch()

    }, [formState.currency_type])

    return (
        <>  
            <div className="pt-4"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="idbanco">* Banco Destino</label>
                        {(loadingFetchBanksByCurrency)&&(<LinearLoading/>)}
                        <CustomAutocomplete 
                            customId="idbanco"
                            customName="idbanco"
                            customValue={formState.idbanco}
                            customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idbanco', value: value.value }})}
                            customPlaceholder='Seleccionar opción'
                            customOptions={
                                dataBanksByCurrency.map(({ idbanco, nombre, currency_type }) => ({
                                    value: idbanco,
                                    name: `${nombre} - ${currency_type}`
                                }))
                            }
                            customDisableClearable={true}
                            customDisabled={true}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="numero_comprobante"> * Número de cheque</label>
                        <TextField
                            id='numero_comprobante'
                            name='numero_comprobante'
                            value={ formState.numero_comprobante } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Ingrese número de cheque'
                            type='text'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="dowload-boleta">* Cheque / comprobante subido</label>
                        <Button
                            startIcon={<DownloadCloud/>}
                            color='success'
                            variant="contained"
                            onClick={
                                (event) => handleClickDownloadImage(
                                    formState.attachments[0].attachment_originalname,
                                    formState.attachments[0].attachment_path
                                )
                            }
                            sx={{textDecoration: 'none', paddingTop: 1}}
                        >Descargar</Button>
                    </FormControl>
                </Grid>
            </Grid>
        </>
    )
}
